module.exports = __webpack_public_path__ + "img/diamond.669e8be6.png";